import styled from 'styled-components';

export const NightModeControlStyle = styled.div.attrs(props => ({
    className: props.className,
}))`
    position: fixed;
    right: 0;
    top: 77px;
    padding: 15px;
    width: 200px;
    z-index: 1000;
    border-radius: 5px;
    transition: all .3s ease;

    @media screen and (max-width:1000px) {
        width: 0px;
        padding: 0;
    }

    & .day-night {
        position: absolute;
        width: 40px;
        height: 40px;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 20px;
        color: var(--color-text);
        right: 100%;
        margin-right: 15px;
        top: 55px;
        cursor: pointer;
        transition: all .3s ease;
        border-radius: 50%;

        &::after {
            border-radius: 50%;
        }
    }

    & h4 {
        margin: 0 0 5px;
        color: var(--color-text2);
        font-size: 1.6rem;
        font-weight: 600;
        text-transform: capitalize;
        letter-spacing: .2rem;
    }

    & .horizontal-line {
        width: 100%;
        height: 10px;
        background-color: var(--color-primary-dark);
    }
`;